import Link from "next/link";

function Privacy(props) {
  const { styles } = props;

  return (
    <>
      <div className={`content-wrapper ${styles.oh}`}>
        <div className={styles.pageTitle}>
          <div className={`container ${styles.relative}`}>
            <h1>Privacy Policy</h1>
            <ol className={styles.breadcrumb}>
              <li>
                <Link href="/">Home</Link>
              </li>
              <li className={styles.active}>Privacy</li>
            </ol>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-9 mb-50">
              <h2 className={styles.heading}>Privacy Policy</h2>
              <p>
                UCBT Operations Pty Limited (ACN 626 754 390) (
                <strong>
                  <em>Drummoyne Rowing Club,&nbsp;</em>we, us&nbsp;
                </strong>
                or <strong>our</strong>
                <em>)&nbsp;</em>and its Related Bodies Corporate (as defined in
                the <em>Corporations Act 2001&nbsp;</em>(Cth)) are committed to
                protecting and maintaining the privacy, accuracy and security of
                the personal information you provide to us.&nbsp;
              </p>
              <p>
                We abide by and are bound by the Australian Privacy Principles
                and the <em>Privacy Act 1988</em> (Cth) (
                <strong>Privacy Act</strong>), which govern the way private
                sector organisations collect, use, keep secure and disclose
                personal information.
              </p>
              <p>
                The Privacy Act defines &ldquo;Personal information&rdquo; to
                mean any information or an opinion about an identified
                individual, or an individual who is reasonably identifiable;
                whether the information is true; and whether the information is
                recorded in material form.
              </p>
              <p>
                &ldquo;Personal Data&rdquo; means any information relating to an
                identified or identifiable natural personal (i.e. by reference
                to an identifier such as a name, an identification number,
                location data, an online identifier or to one or more factors
                specific to the physical, physiological, genetic, mental,
                economic, cultural or social identity of that person). We are
                required to comply EU General Data Protection Regulation (GDPR)
                for persons located in the European Union in relation to your
                Personal Data. Please refer to section 10 if this applies to
                you.
              </p>
              <h4>About this Privacy Policy</h4>
              <p>The purpose of this Privacy Policy is to explain:</p>
              <ul className={styles.ulData}>
                <li>the scope and application of this Privacy Policy;</li>
                <li>
                  the kind of Personal Information and Personal Data{" "}
                  <em>Drummoyne Rowing Club</em> may collect about you and how
                  we collect the information;
                </li>
                <li>how we use your Personal Information and Personal Data;</li>
                <li>
                  how we may disclose your Personal Information and Personal
                  Data;
                </li>
                <li>
                  how we protect the Personal Information and Personal Data we
                  hold about you; and
                </li>
                <li>
                  how you can access and manage, including transfer and delete,
                  the Personal Information and Personal Data we hold about you.
                </li>
              </ul>
              <p>
                This Privacy Policy applies to Personal Information and Personal
                Data collected by <em>Drummoyne Rowing Club</em> by any means or
                technology.By using the <em>Drummoyne Rowing Club</em> App or
                the website operated by <em>Drummoyne Rowing Club&nbsp;</em>
                (&ldquo;platform&rdquo;), or otherwise interacting with us in
                relation to the service offered by us and the products and
                services offered by our business partners (including
                participating in offered promotions), you consent to{" "}
                <em>Drummoyne Rowing Club</em> using your Personal Information
                and Personal Data as set out in this Privacy Policy.
              </p>
              <p>
                If you have any concerns or questions, please contact us at the
                details set out in section 9 and our privacy officer will
                resolve your concerns and answer your questions (resident of the
                European Union, refer to section 10).
              </p>
              <p>
                <strong>Links to other sites</strong>
              </p>
              <p>
                Our platform may contain links to other sites, including our
                business partners who are offering products and services via{" "}
                <em>Drummoyne Rowing Club</em>&rsquo; s platform, that are not
                owned or controlled by <em>Drummoyne Rowing Club</em>. Please be
                aware that we are not responsible for the privacy practices of
                such other sites and you access these sites at your own risk.
                You should therefore familiarise yourself with privacy policies
                of those sites.
              </p>
              <h4>
                Section I: What kind of Personal Information and Personal Data
                do we collect and hold?
              </h4>
              <p>
                In the process of conducting our business, we are likely to
                collect a range of Personal Information or Personal Data from or
                about you. The types of Personal Information or Personal Data we
                collect generally includes:
              </p>
              <ul className={styles.ulData}>
                <li>your name, your Company name;</li>
                <li>residential, shipping and billing addresses;</li>
                <li>email address;</li>
                <li>telephone or mobile numbers;&nbsp;</li>
                <li>username and password stored with us;</li>
                <li>
                  other Personal Information or Personal Data that may be
                  volunteered by you in the content of any enquiry you make with
                  us;
                </li>
                <li>
                  any Personal Information or Personal Data collected as a
                  result of your interactions with, or posts about, us on blogs
                  and forums online such as: user account information and any
                  other Personal Information or Personal Data contained in such
                  a post;
                </li>
                <li>
                  Personal Information or Personal Data collects as a result of
                  your interactions with us on social media, through feedback
                  and surveys or entry into any competitions;
                </li>
                <li>
                  interests and information about your transactions with us or
                  our business partners, including the products and services
                  provided to you though or by our business partners through the
                  use of our platform.
                </li>
              </ul>
              <p>
                If you utilise our platform, we may use technology to collect
                information as to your activities, including the IP address of
                your computer (or other devices), your browsing history on our
                platform and transactional data including your product scanning,
                auction and payment history.
              </p>
              <p>
                If you are an employee or contractor with{" "}
                <em>Drummoyne Rowing Club</em>, we will collect the following
                information from you:&nbsp;
              </p>
              <ul className={styles.ulData}>
                <li>
                  contact information such as your name, email address, postal
                  and residential address, phone numbers, country of residence,
                  next of kin contact details;&nbsp;
                </li>
                <li>employee record information;&nbsp;</li>
                <li>
                  identifying information such as: your photo, passport and
                  residency details, date of birth, licence;
                </li>
                <li>
                  CV, resume or application related information (including
                  references);&nbsp;
                </li>
                <li>Tax, superannuation and payroll information;&nbsp;</li>
                <li>
                  Background checks information (which may be obtained from you
                  or third parties).
                </li>
              </ul>
              <p>
                In general, we do not collect &quot;sensitive information&quot;
                (such as information about ethnic origin, religious or political
                views, health information etc) from you.
              </p>
              <p>
                <strong>Credit card information</strong>
              </p>
              <p>
                We do not store any credit card information obtained through our
                platform. We pass it onto our bank or where applicable, our
                supplier for processing. If you use Stripe, Apple Pay, Google
                Pay or After Pay to complete your transaction, your Personal
                Information or Personal Data (including credit card information)
                will be collected and used by those parties in accordance with
                their individual privacy policies, which are available on their
                websites for review.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>Anonymity and pseudonymity</strong>
              </p>
              <p>
                Due to the nature of the services we provide and the goods
                offered for sale on our platform, it is only practicable or
                reasonable for <em>Drummoyne Rowing Club</em> to deal with you
                on a named basis. Your Personal Information or Personal Data may
                be required in order to provide you with our services or the
                products you purchase on our platform from our business
                partners, or to resolve any issue you may have.
              </p>
              <p>&nbsp;</p>
              <h4>
                Section II: How do we collect Personal Information and Personal
                Data?
              </h4>
              <p>
                <em>Drummoyne Rowing Club</em> collects Personal Information or
                Personal Data directly from you when you submit it via the
                platform operated by <em>Drummoyne Rowing Club</em>.
              </p>
              <p>
                We may also collect Personal Information or Personal Data from
                publicly available sources or third parties, such as via our
                business partners, where we are responsible for delivering goods
                directly to you, or social media platforms such as Facebook or
                Twitter.
              </p>
              <p>
                Depending on the reason for requiring the information, some of
                the information we ask you to provide may be identified as
                mandatory or voluntary. If you do not provide the mandatory
                information or any other information we require in order for us
                to provide our services to you or the products you purchase on
                our platform from our business partners, we may be unable to
                provide our services to you in an effective manner, or at all.
              </p>
              <p>
                If we collect details about you from someone else, we will,
                whenever reasonably possible, make you aware that we have done
                this and why unless: (a) the information has been provided by
                you on application to register or work with{" "}
                <em>Drummoyne Rowing Club</em>, (b) such information is publicly
                available or (c) as otherwise required or authorised by law.
              </p>
              <p>
                <strong>
                  Unsolicited Personal Information or Personal Data
                </strong>
              </p>
              <p>
                In the event that we collect unsolicited Personal Information or
                Personal Data from you, or a third party, in circumstances where
                we have not requested or solicited that information, and it is
                determined in the sole discretion of{" "}
                <em>Drummoyne Rowing Club</em>, that the Personal Information or
                Personal Data is not required, we will destroy the information
                or ensure that it is de-identified.However, where such
                information or data relates to your engagement with or by{" "}
                <em>Drummoyne Rowing Club</em> we may choose to keep that.
              </p>
              <p>
                <strong>
                  How to we hold your Personal Information or Personal Data?
                </strong>
              </p>
              <p>
                Once we collect your Personal Information or Personal Data, we
                will either hold it securely and store it on infrastructure
                owned or controlled by us or with a third party service provider
                who has taken reasonable steps to ensure they comply with the
                Privacy Act.&nbsp;
              </p>
              <p>
                <strong>Cookies and IP addresses</strong>
              </p>
              <p>
                A cookie is a small amount of data, which may include a unique
                identifier. Cookies are sent to your browser from a website and
                stored on your device. We assign a different cookie to each
                device that accesses our website. We use cookies to recognize
                your device, monitor traffic patterns and trends, and provide
                you with a personalized experience on our sites. In most cases,
                cookies do not identify you personally but may identify your
                internet service provider or computer.For example,{" "}
                <em>Drummoyne Rowing Club</em> does use cookies to identify
                repeat users and make it easier for you to navigate our site and
                where applicable, provide customer services to you. We do not
                share that information with third parties. You do not need to
                allow the use of cookies on our site, however, if you reject
                cookies your ability to use some features of our site will be
                limited.&nbsp;
              </p>
              <p>
                Some of our media partners may also use cookies on our site. We
                have no access to or control over these tracking technologies.
                This information is generally not personally identifiable and is
                analysed to determine user preferences and provide feedback so
                we can make improvements to our site.&nbsp;
              </p>
              <h4>
                Section III: How do we use Personal Information and Personal
                Data?
              </h4>
              <p>
                <strong>Use Details</strong>
              </p>
              <p>
                <em>Drummoyne Rowing Club</em> may use your Personal Information
                or Personal Data for the purposes for which it was initially
                collected or purposes related to such initial purpose if such
                purposes would be within your reasonable expectations. For
                example, to:
              </p>
              <ul className={styles.ulData}>
                <li>
                  provide you with our services and information in relation our
                  business partners&rsquo; products being sold via{" "}
                  <em>Drummoyne Rowing Club</em> (which may include warranty
                  services, repairs and replacement of products and customer
                  care plan services, promotions and competitions);
                </li>
                <li>
                  delivery of products procured via{" "}
                  <em>Drummoyne Rowing Club</em> and to respond to questions in
                  relation to those products and the transaction to which they
                  relate;
                </li>
                <li>
                  forecast your future needs for our business partners&rsquo;
                  products;
                </li>
                <li>
                  keep a record of our dealings with each other and enable us to
                  contact you when necessary;
                </li>
                <li>
                  develop a data profile to enable us to tailor our services to
                  you;&nbsp;
                </li>
                <li>
                  marketing products and services of our business partners to
                  you that <em>Drummoyne Rowing Club&nbsp;</em>considers may be
                  of interest to you;
                </li>
                <li>
                  in the sale of any part of{" "}
                  <em>Drummoyne Rowing Club&rsquo;s</em> business or a company
                  owned by <em>Drummoyne Rowing Club;</em> or
                </li>
                <li>
                  (where applicable) conduct promotions in which you
                  participated.
                </li>
              </ul>
              <p>
                Where you are a contractor or an employee of{" "}
                <em>Drummoyne Rowing Club,&nbsp;</em>your Personal Information
                or Personal Data may be used to:&nbsp;
              </p>
              <ul className={styles.ulData}>
                <li>addressing your suitability for a role;&nbsp;</li>
                <li>
                  for the purposes of administration and performance monitoring
                  uses; or
                </li>
                <li>
                  in the sale of any part of{" "}
                  <em>Drummoyne Rowing Club&rsquo;s</em> business or a company
                  owned by <em>Drummoyne Rowing Club</em>.
                </li>
              </ul>
              <p>
                We may also use your Personal Information and Personal Data for
                purposes authorised by laws or regulations, such as to prevent
                or investigate an alleged crime or fraud (and we are not
                required to seek your further consent).
              </p>
              <p>
                Furthermore, <em>Drummoyne Rowing Club</em> may also use or
                disclose your Personal Information or Personal Data, and we are
                not required to seek your further consent:&nbsp;
              </p>
              <ul className={styles.ulData}>
                <li>
                  when it is disclosed or used for a purpose related to the
                  primary purposes of collection (detailed above), and you would
                  reasonably expect your Personal Information or Personal Data
                  to be used or disclosed for such a purpose;&nbsp;
                </li>
                <li>
                  if we reasonably believe that the use or disclose is necessary
                  to lessen or prevent a serious or imminent threat to an
                  individual&rsquo;s life, health or safety or to lessen or
                  prevent a threat to public health or safety;&nbsp;
                </li>
                <li>
                  if we have reason to suspect that unlawful activity has been,
                  or is being engaged in; or&nbsp;
                </li>
                <li>if it is required or authorised by law.</li>
              </ul>
              <p>
                <strong>Procedures&nbsp;</strong>
              </p>
              <p>
                In the event that we propose to use or disclose your Personal
                Information or Personal Data other than for reasons set out
                above, we will first notify you and seek your consent to such
                disclosure or use. Your Personal Information or Personal Data is
                only disclosed to organisations or parties for purposes of us
                providing you with products or services from our business
                partners. We take such steps as a reasonable to ensure that
                these organisations or parties are aware of the provisions of
                this Privacy Policy in relation to your Personal Information or
                Personal Data.
              </p>
              <h4>Section IV: Direct marketing</h4>
              <p>
                <em>Drummoyne Rowing Club</em> may also, from time to time, use
                your Personal Information or Personal Data to contact you to
                identify promotions, competitions, products and services offered
                by our business partners that may be of interest to you.
              </p>
              <p>
                <strong>Consent&nbsp;</strong>
              </p>
              <p>
                By supplying us your information, you provide us with your
                express and informed consent to communicate with you via email,
                SMS, MMS, social media or post to inform you about products and
                services offered by us or our business partners which we
                consider are relevant to you (
                <strong>Direct Marketing Communications</strong>).&nbsp;
              </p>
              <p>
                Without limitation to the preceding paragraph, if you have
                provided, inferred or implied consent (i.e. not opting out where
                an opt-out opportunity has been provided to you) or if it is
                within your reasonable expectation that we send you Direct
                Marketing Communications given the transaction or communication
                you have had with us, then we may also use your Personal
                Information or Personal Data for the purpose of sending you
                Direct Marketing Communications which we consider may be of
                interest to you.
              </p>
              <p>
                <strong>Communications opt-out</strong>
              </p>
              <p>
                This permission is not limited in time unless you choose to opt
                out by contacting us using the contact information provided
                below, or by utilising an &#39; unsubscribe&#39; facility on a
                communication we send to you in which case,{" "}
                <em>Drummoyne Rowing Club</em> will take steps to ensure you do
                not receive any future such Direct Marketing Communication.
              </p>
              <p>
                Some business partners of <em>Drummoyne Rowing Club</em>{" "}
                advertise with Google. Google may show you these advertisements
                based on your previous visits to our site. If you do not wish to
                see these advertisements you can opt-out by visiting the Google
                advertising opt-out page here:&nbsp;
                <Link
                  href="https://policies.google.com/technologies/ads"
                  target="_blank"
                >
                  https://policies.google.com/technologies/ads
                </Link>
              </p>
              <p>&nbsp;</p>
              <h4>
                Section V: Disclosure of Personal Information or Personal Data
              </h4>
              <p>
                We will never sell, rent, lease or disclose your Personal
                Information or Personal Data to other organisations, except as
                outlined in this Privacy Policy.Personal Information or Personal
                Data provided to a member of the <em>Drummoyne Rowing Club</em>{" "}
                group of companies may be shared within the{" "}
                <em>Drummoyne Rowing Club</em> companies within the group. In
                addition, we may disclose your Personal Information or Personal
                Data to organisations outside
                <em>&nbsp;Drummoyne Rowing Club</em> such, as our business
                partners and others, which assists us to deliver products and
                services procured via our platform. These third parties are too
                numerous to list and will change from time to time. Some
                examples of the types of such organisations may include, but are
                not limited to:
              </p>
              <ul className={styles.ulData}>
                <li>
                  the business partners who utilise our{" "}
                  <em>Drummoyne Rowing Club&nbsp;</em>platform;&nbsp;
                </li>
                <li>
                  our business partners and Related Bodies Corporate (as defined
                  in the <em>Corporations Act 2001&nbsp;</em>(Cth)) being the
                  product and service suppliers to you and their delivery
                  partners;
                </li>
                <li>
                  financial services providers, such as our banks or third-party
                  suppliers for securing payment of the products or services
                  provided to you via our platform, such as Apple Pay, PayPal,
                  Google Pay, Stripe and After Pay, and where applicable credit
                  report agencies or debt collectors;
                </li>
                <li>
                  technology service providers, such as internet service
                  providers, database management services, digital mail
                  providers who send communications on our behalf, live help
                  service providers and service providers for the prevention of
                  fraud and protection of data;
                </li>
                <li>
                  service providers who perform market research or manage or
                  review the services provided to you;
                </li>
                <li>
                  mailing systems and courier companies, which organise delivery
                  of the products you have purchased via the platform; and
                </li>
                <li>
                  our professional advisers, accountants, lawyers and
                  auditors;&nbsp;
                </li>
                <li>
                  third parties in connection with the sale of any part of{" "}
                  <em>Drummoyne Rowing Club&rsquo;s</em> business or a company
                  owned by Drummoyne Rowing Club;&nbsp;
                </li>
                <li>as required or authorised by law;</li>
                <li>
                  (in addition to the above) in the case you are engaged by{" "}
                  <em>Drummoyne Rowing Club</em> as a contractor or employee, to
                  Government departments, superannuation companies,
                  worker&rsquo;s compensation organisations, third party
                  referees; recruitment agents, financial institutions for
                  payroll purposes.
                </li>
              </ul>
              <h4>Section VI: Cross border disclosure&nbsp;</h4>
              <p>
                <em>Drummoyne Rowing Club&rsquo;s&nbsp;</em>servers are located
                in Australia, and so when we are storing your Personal
                Information or Personal Data we only store it in
                Australia.&nbsp;
              </p>
              <p>
                The third parties (including our IT service providers) listed
                above that we utilise to assist us and our business partners in
                providing products and services to you, may be located in
                Australia or overseas. As we use service providers and platforms
                which can be accessed from various countries via an Internet
                connection, it is not always practicable to know where your
                information may be held. If your information or data is stored
                in this way, disclosures may occur to destination outside
                Australia, including (but not limited to) the United States or
                other countries.
              </p>
              <p>
                <strong>Informed consent</strong>
              </p>
              <p>
                By submitting your Personal Information or Personal Data to{" "}
                <em>Drummoyne Rowing Club</em>, you expressly agree and consent
                to the disclosure, transfer, storing or processing of your
                Personal Information or Personal Data outside of Australia. In
                providing this consent, you understand and acknowledge that
                countries outside Australia do not always have the same privacy
                protection obligations as Australia in relation to Personal
                Information or Personal Data. &nbsp; However, we will take steps
                to ensure that your information is used by third parties
                securely and in accordance with the terms of this Privacy
                Policy.&nbsp;
              </p>
              <p>
                The Privacy Act requires us to take such steps as are reasonable
                in the circumstances to ensure that any recipients of your
                Personal Information or Personal Data outside of Australia do
                not breach the privacy principles contained within the Privacy
                Act. &nbsp;By providing your consent, under the Privacy Act, we
                are not required to take such steps as may be reasonable in the
                circumstances. &nbsp;However, despite this, we acknowledge the
                importance of protecting Personal Information or Personal Data
                and have taken reasonable steps to ensure that your information
                is used by third parties securely and in accordance with the
                terms of this Privacy Policy.
              </p>
              <p>
                If you do not agree to the disclosure of your Personal
                Information or Personal Data outside Australia by{" "}
                <em>Drummoyne Rowing Club</em>, you should (after being informed
                of the cross border disclosure) tell{" "}
                <em>Drummoyne Rowing Club</em> that you do not consent.To do
                this, either elect not to submit the Personal Information or
                Personal Data to <em>Drummoyne Rowing Club</em> after being
                reasonably informed in a collection notification or please
                contact us via the details set out at in Section X below.
              </p>
              <h4>Section VII: Data Security and Quality</h4>
              <p>
                <em>Drummoyne Rowing Club</em> takes reasonable steps to ensure
                that your Personal Information or Personal Data is protected
                from misuse, interference or loss and unauthorised access,
                modification or disclosure. We have systems and procedures in
                place to protect your privacy whenever we collect, store, and
                use or disclose Personal Information or Personal Data. We will
                regularly upgrade these systems and review our procedures to
                ensure high standards of security are used to protect your
                Personal Information or Personal Data.As a condition of working
                for <em>Drummoyne Rowing Club</em> all our employees and service
                providers sign up to express confidentiality obligations.
                However, since no system is 100% secure or error free, we cannot
                guarantee that your Personal Information or Personal Data is
                totally protected, for example, from hackers or misuse. If you
                enter Personal Information or Personal Data on our platform, you
                should exercise due care to safeguard any passwords, ID number,
                or other special access features associated with your use of our
                platform.
              </p>
              <p>
                We will take reasonable steps to destroy or permanently
                de-identify Personal Information or Personal Data from our
                systems which is no longer required by us.
              </p>
              <h4>
                Section VIII: How to access and amend Personal Information or
                Personal Data
              </h4>
              <p>
                We strive to keep your Personal Information and Personal Data
                accurate, up-to-date and complete. You are entitled to find out
                what information we hold about you and correct that information
                if it is wrong, incomplete, out of date, misleading or
                irrelevant.
              </p>
              <p>
                If you become aware that any information we hold about you is
                incorrect or out-of-date, please let us know immediately via the
                contact details set out below at section 9. We will be happy to
                accept updated Personal Information or Personal Data in writing
                from the owner of that information at any time. However, in
                order to protect your privacy and security, we will take
                reasonable steps to verify your identity before granting you
                access or enabling you to make corrections to your Personal
                Information or Personal Data.&nbsp;
              </p>
              <p>
                Our objective is to respond to any request within a reasonable
                timeframe and no later than 30 days. We will inform you if this
                timeframe is not achievable.
              </p>
              <p>
                In some circumstances,<em>&nbsp;Drummoyne Rowing Club</em> may
                not be in a position to grant access to Personal Information or
                Personal Data, such circumstances include:
              </p>
              <ul className={styles.ulData}>
                <li>
                  providing access is likely to pose a serious threat to the
                  safety of an individual or the public;
                </li>
                <li>
                  providing access is likely to unreasonably impact on the
                  privacy of others;
                </li>
                <li>the request for access is frivolous or vexatious;</li>
                <li>
                  providing access would reveal information which relates to
                  existing or anticipated legal proceedings or otherwise impact
                  on any negotiations;
                </li>
                <li>
                  providing access is unlawful (including being unlawful as
                  directed by a court or tribunal order) or is likely to impact
                  on actions being taken in relation to alleged unlawful
                  activities relating to the functions and activities of{" "}
                  <em>Drummoyne Rowing Club</em>; or
                </li>
                <li>
                  granting access would impact on a commercially sensitive
                  decision-making process.
                </li>
              </ul>
              <h4>Section IX: Complaints</h4>
              <p>
                We encourage and value your feedback. If you have any questions
                about our Privacy Policy, or have a problem or complaint, please
                let us know. We will respond to a complaint as soon as possible,
                but within 5 Business Days to let you know who is responsible
                for managing your complaint. We will also try to resolve the
                complaint within 10 Business Days. When this is not possible, we
                will contact you within that time to let you know how long it
                will take to resolve the complaint.
              </p>
              <p>In order to resolve a complaint, we:</p>
              <ul className={styles.ulData}>
                <li>
                  will liaise with you to identify and define the nature and
                  cause of the complaint;
                </li>
                <li>
                  may request that you provide the details of the complaint in
                  writing;
                </li>
                <li>
                  will keep you informed of the likely time within which we will
                  respond to your complaint; and&nbsp;
                </li>
                <li>
                  will inform you of the legislative basis (if any) of our
                  decision in resolving such complaint.
                </li>
              </ul>
              <br />
              <p style={{ lineHeight: "15px", margin: "0px" }}>
                Our contact details are:
              </p>
              <p style={{ lineHeight: "15px", margin: "0px" }}>
                UCBT Operations Pty Ltd
              </p>
              <p style={{ lineHeight: "15px", margin: "0px" }}>
                Shop 13, 45-55 Harris Street, Pyrmont NSW, 2009
              </p>
              <p style={{ lineHeight: "15px", margin: "0px" }}>
                Attention: Privacy Officer
              </p>
              <p style={{ lineHeight: "15px", margin: "0px" }}>
                E-mail:mark@betterthat.com
              </p>

              <p>
                If you believe <em>Drummoyne Rowing Club</em> has not adequately
                dealt with your complaint, you may complain to the Privacy
                Commissioner, whose contact details are found at&nbsp;
                <Link href="http://www.oaic.gov.au" target="_blank">
                  www.oaic.gov.au
                </Link>
                <em>.</em>
              </p>

              <p>
                We will keep a record of the complaint and any action taken in a
                Register of Complaints.
              </p>
              <h4>Section X: GDPR</h4>
              <p>
                <strong>Definitions</strong>
              </p>
              <p>
                In providing our or our business partners&rsquo; products and
                services, or collecting and using your Personal Data, we are
                required to comply with the GDPR where you are a European Union
                resident.&nbsp;
              </p>
              <p>The following defined terms have the associated meanings:</p>
              <ul className={styles.ulData}>
                <li>
                  &ldquo;<strong>Data Subject</strong>&rdquo; has the meaning
                  attributed to that term in the GDPR.
                </li>
                <li>
                  &ldquo;<strong>GDPR</strong>&rdquo; means Regulation (EU)
                  2016/679 of the European Parliament and of the Council of 27
                  April 2016 on the protection of natural persons with regard to
                  the processing of Personal Data and on the free movement of
                  such data, and repealing Directive 95/46/EC; and
                </li>
                <li>
                  &ldquo;<strong>Personal Data</strong>&rdquo; means the
                  Personal Data (having the meaning attributed to that term in
                  the GDPR) of the Data Subjects whose data is processed for the
                  purposes of the provision of our retail services.
                </li>
              </ul>
              <p style={{ lineHeight: "15px", margin: "0px" }}>
                <strong>GDPR Obligations</strong>
              </p>
              <p style={{ lineHeight: "15px", margin: "0px" }}>
                If you are a resident of the European Union for the purposes of
                the GDPR, then in addition to what is set out in Sections 1 - 9
                above, the following applies to you.
              </p>
              <p style={{ lineHeight: "18px", margin: "0px" }}>
                Under the GDPR, <em>Drummoyne Rowing Club&nbsp;</em>is
                considered a &ldquo;data processor&rdquo; in the provision of
                its platform that facilitates the buying and selling of retail
                goods and services.&nbsp;
              </p>
              <p style={{ lineHeight: "18px", margin: "0px" }}>
                In addition to your rights of access and correction as set out
                above, as a Data Subject you may:
              </p>
              <ul className={styles.ulData}>
                <li>
                  (<strong>access</strong>) request access to your Personal Data
                  held by <em>Drummoyne Rowing Club</em>;
                </li>
                <li>
                  (<strong>rectification</strong>) request to update or rectify
                  any of the Personal Data that we hold about you by contacting
                  us at the details specified above and request Personal Data
                  updates;
                </li>
                <li>
                  (<strong>erasure</strong>) withdraw your consent to{" "}
                  <em>Drummoyne Rowing Club&rsquo;s</em> use of your Personal
                  Data as described in this policy by deletion or erasure of
                  your Personal Data that we hold where that data is no longer
                  required for the purpose for which it was collected;&nbsp;
                </li>
                <li>
                  (<strong>restriction on processing</strong>) obtain from the
                  controller (usually, this is your employer) a restriction on
                  processing of your Personal Data where:&nbsp;
                </li>
              </ul>
              <ul className={styles.ul2Data}>
                <li>accuracy of the Personal Data is contested;&nbsp;</li>
                <li>
                  the processing by the processor is unlawful (and you oppose
                  erasure but request restriction of use);&nbsp;
                </li>
                <li>
                  <em>Drummoyne Rowing Club</em> no longer needs your Personal
                  Data; or
                </li>
                <li>
                  you have objected to processing pursuant to your right to
                  object under Article 21(1) of the GDPR;
                </li>
              </ul>

              <ul className={styles.ulData}>
                <li>
                  (<strong>data portability</strong>) request that{" "}
                  <em>Drummoyne Rowing Club</em>:&nbsp;
                </li>
              </ul>
              <ul className={styles.ul2Data}>
                <li>
                  provides you with a copy of the Personal Data that{" "}
                  <em>Drummoyne Rowing Club</em> holds about you in a portable
                  and machine readable form; or&nbsp;
                </li>
                <li>share your Personal Data with a nominated third party.</li>
              </ul>

              <p>
                <strong>Exercising Data Subject rights</strong>
              </p>
              <p style={{ lineHeight: "18px", margin: "0px" }}>
                If you wish to exercise any of your Data Subject rights, then
                please send your request in writing to the details above in this
                section.
              </p>
              <p style={{ lineHeight: "18px", margin: "0px" }}>
                We will process your request promptly and in any event, within
                one month of receipt of receiving it.
              </p>
              <p>
                <strong>Complaints&nbsp;</strong>
              </p>
              <p style={{ lineHeight: "18px", margin: "0px" }}>
                If you have any concerns in relation to{" "}
                <em>Drummoyne Rowing Club&rsquo;s</em> collection or processing
                of your Personal Data, then you also have a right to complain to
                a supervisory authority (within the meaning of the GDPR).
              </p>
              <h4>Section XI: Consent and changes in this Privacy Policy</h4>
              <p>
                <strong>Modifications and updates</strong>
              </p>
              <p>
                We reserve the right to modify this Privacy Policy at any time,
                so please review it frequently.Changes to this Privacy Policy
                will be published by posting an updated Privacy Policy on the{" "}
                <em>Drummoyne Rowing Club</em> platform. If we make material
                changes to this policy, we will notify you here, by email, or by
                means of a notice on our home page.
              </p>
              <p>
                <strong>Interaction of this policy with contracts</strong>
              </p>
              <p>
                This Privacy Policy is a compliance document, rather than a
                legal contract between two or more persons. However, certain
                contracts may incorporate all, or part of this Privacy Policy,
                into the terms of that contract. In such instances,
                <em>Drummoyne Rowing Club</em> may incorporate the terms of this
                policy such that certain sections or parts are incorporated, and
                the consents provided by this policy become contractual terms
                provided by the other party to the contract.&nbsp;
              </p>
              <p>
                <strong>Last updated:</strong>&nbsp; &nbsp;20 November 2018
              </p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Privacy;
